'use client';
import { ReactComponent as Quote } from '@mnd-frontend/svgs/quote.svg?react';
import type { FC } from 'react';
import styled from 'styled-components';
import SvgIconWrapper from './SvgIconWrapper';
import { ReactComponent as AddToList } from './svgs/add-to-list.svg?react';
import { ReactComponent as AdminShield } from './svgs/admin-shield.svg?react';
import { ReactComponent as AdminShieldCookie } from './svgs/admin-shield-cookie.svg?react';
import { ReactComponent as Analyze } from './svgs/analyze.svg?react';
import { ReactComponent as AnalyzeAlt } from './svgs/analyze-alt.svg?react';
import { ReactComponent as AnalyzeMenu } from './svgs/analyze-menu.svg?react';
import { ReactComponent as AnalyzeNavigationActive } from './svgs/analyze-navigation-active.svg?react';
import { ReactComponent as ArrowDown } from './svgs/arrow-down.svg?react';
import { ReactComponent as ArrowDownRight } from './svgs/arrow-down-right.svg?react';
import { ReactComponent as ArrowLeft } from './svgs/arrow-left.svg?react';
import { ReactComponent as ArrowRight } from './svgs/arrow-right.svg?react';
import { ReactComponent as ArrowUp } from './svgs/arrow-up.svg?react';
import { ReactComponent as ArrowUpRight } from './svgs/arrow-up-right.svg?react';
import { ReactComponent as Astromech } from './svgs/astromech.svg?react';
import { ReactComponent as Benchmark } from './svgs/benchmark.svg?react';
import { ReactComponent as Binoculars } from './svgs/binoculars.svg?react';
import { ReactComponent as Blog } from './svgs/blog.svg?react';
import { ReactComponent as Boolean } from './svgs/boolean.svg?react';
import { ReactComponent as Code } from './svgs/browser-embed.svg?react';
import { ReactComponent as Calendar } from './svgs/calendar.svg?react';
import { ReactComponent as Chat } from './svgs/chat.svg?react';
import { ReactComponent as Check } from './svgs/check.svg?react';
import { ReactComponent as ChevronDown } from './svgs/chevron-down.svg?react';
import { ReactComponent as ChevronLeft } from './svgs/chevron-left.svg?react';
import { ReactComponent as ChevronRight } from './svgs/chevron-right.svg?react';
import { ReactComponent as ChevronUp } from './svgs/chevron-up.svg?react';
import { ReactComponent as CircleCheck } from './svgs/circle-check.svg?react';
import { ReactComponent as CircleClock } from './svgs/circle-clock.svg?react';
import { ReactComponent as CircleCross } from './svgs/circle-cross.svg?react';
import { ReactComponent as CircleError } from './svgs/circle-error.svg?react';
import { ReactComponent as CircleInfo } from './svgs/circle-info.svg?react';
import { ReactComponent as CircleInfoFilled } from './svgs/circle-info-filled.svg?react';
import { ReactComponent as CirclePlus } from './svgs/circle-plus.svg?react';
import { ReactComponent as CircleQuestion } from './svgs/circle-question.svg?react';
import { ReactComponent as CircleSlash } from './svgs/circle-slash.svg?react';
import { ReactComponent as CircleUser } from './svgs/circle-user.svg?react';
import { ReactComponent as Close } from './svgs/close.svg?react';
import { ReactComponent as Collapse } from './svgs/collapse.svg?react';
import { ReactComponent as Comment } from './svgs/comment.svg?react';
import { ReactComponent as Computer } from './svgs/computer.svg?react';
import { ReactComponent as Contact } from './svgs/contact.svg?react';
import { ReactComponent as ContactPlus } from './svgs/contact-add.svg?react';
import { ReactComponent as ContactCheck } from './svgs/contact-check.svg?react';
import { ReactComponent as Contacts } from './svgs/contacts.svg?react';
import { ReactComponent as ContactsNavigation } from './svgs/contacts-navigation.svg?react';
import { ReactComponent as ContactsNavigationActive } from './svgs/contacts-navigation-active.svg?react';
import { ReactComponent as Copy } from './svgs/copy.svg?react';
import { ReactComponent as CreditCard } from './svgs/credit-card.svg?react';
import { ReactComponent as Crown } from './svgs/crown.svg?react';
import { ReactComponent as CrowFancy } from './svgs/crown-fancy.svg?react';
import { ReactComponent as Dashboard } from './svgs/dashboard.svg?react';
import { ReactComponent as DashboardActive } from './svgs/dashboard-active.svg?react';
import { ReactComponent as Debug } from './svgs/debug.svg?react';
import { ReactComponent as DebugCookie } from './svgs/debug-cookie.svg?react';
import { ReactComponent as DefaultThumbnail } from './svgs/default-thumbnail.svg?react';
import { ReactComponent as Delete } from './svgs/delete.svg?react';
import { ReactComponent as DeleteSchedule } from './svgs/delete-schedule.svg?react';
import { ReactComponent as Diamond } from './svgs/diamond.svg?react';
import { ReactComponent as Differences } from './svgs/differences.svg?react';
import { ReactComponent as DollarSign } from './svgs/dollar-sign.svg?react';
import { ReactComponent as Download } from './svgs/download.svg?react';
import { ReactComponent as EasterEgg } from './svgs/easter-egg.svg?react';
import { ReactComponent as Edit } from './svgs/edit.svg?react';
import { ReactComponent as Email } from './svgs/email.svg?react';
import { ReactComponent as EmailSchedule } from './svgs/email-schedule.svg?react';
import { ReactComponent as Expand } from './svgs/expand.svg?react';
import { ReactComponent as ExternalLink } from './svgs/external-link.svg?react';
import { ReactComponent as Forum } from './svgs/forum.svg?react';
import { ReactComponent as Globe } from './svgs/globe.svg?react';
import { ReactComponent as Heart } from './svgs/heart.svg?react';
import { ReactComponent as HeartFilled } from './svgs/heart-filled.svg?react';
import { ReactComponent as Image } from './svgs/image.svg?react';
import { ReactComponent as LayoutCompact } from './svgs/layout-compact.svg?react';
import { ReactComponent as LayoutStandard } from './svgs/layout-standard.svg?react';
import { ReactComponent as LearningVideo } from './svgs/learning-video.svg?react';
import { ReactComponent as Lightbulb } from './svgs/lightbulb.svg?react';
import { ReactComponent as Lighthouse } from './svgs/lighthouse.svg?react';
import { ReactComponent as Link } from './svgs/link.svg?react';
import { ReactComponent as List } from './svgs/list.svg?react';
import { ReactComponent as LockLocked } from './svgs/lock-locked.svg?react';
import { ReactComponent as LockUnlocked } from './svgs/lock-unlocked.svg?react';
import { ReactComponent as Menu } from './svgs/menu.svg?react';
import { ReactComponent as Minus } from './svgs/minus.svg?react';
import { ReactComponent as MndFilled } from './svgs/mnd-filled.svg?react';
import { ReactComponent as Monitor } from './svgs/monitor.svg?react';
import { ReactComponent as MonitorNavigation } from './svgs/monitor-navigation.svg?react';
import { ReactComponent as MonitorNavigationActive } from './svgs/monitor-navigation-active.svg?react';
import { ReactComponent as Moon } from './svgs/moon.svg?react';
import { ReactComponent as MoreHorizontal } from './svgs/more-horizontal.svg?react';
import { ReactComponent as MoreVertical } from './svgs/more-vertical.svg?react';
import { ReactComponent as Newsroom } from './svgs/newsroom.svg?react';
import { ReactComponent as Notification } from './svgs/notification.svg?react';
import { ReactComponent as Paperclip } from './svgs/paperclip.svg?react';
import { ReactComponent as PasswordUnlock } from './svgs/password-unlock.svg?react';
import { ReactComponent as Pen } from './svgs/pen.svg?react';
import { ReactComponent as Pencil } from './svgs/pencil.svg?react';
import { ReactComponent as Phone } from './svgs/phone.svg?react';
import { ReactComponent as Pin } from './svgs/pin.svg?react';
import { ReactComponent as PinFilled } from './svgs/pin-filled.svg?react';
import { ReactComponent as Plane } from './svgs/plane.svg?react';
import { ReactComponent as Play } from './svgs/play.svg?react';
import { ReactComponent as PlayFilled } from './svgs/play-filled.svg?react';
import { ReactComponent as Plus } from './svgs/plus.svg?react';
import { ReactComponent as Podcast } from './svgs/podcast.svg?react';
import { ReactComponent as Publish } from './svgs/publish.svg?react';
import { ReactComponent as PublishActive } from './svgs/publish-active.svg?react';
import { ReactComponent as Radio } from './svgs/radio.svg?react';
import { ReactComponent as Reach } from './svgs/reach.svg?react';
import { ReactComponent as Refresh } from './svgs/refresh.svg?react';
import { ReactComponent as Replace } from './svgs/replace.svg?react';
import { ReactComponent as Report } from './svgs/report.svg?react';
import { ReactComponent as ReportsActive } from './svgs/reports-active.svg?react';
import { ReactComponent as Rss } from './svgs/rss.svg?react';
import { ReactComponent as Search } from './svgs/search.svg?react';
import { ReactComponent as Section } from './svgs/section.svg?react';
import { ReactComponent as SentimentNegative } from './svgs/sentiment-negative.svg?react';
import { ReactComponent as SentimentNeutral } from './svgs/sentiment-neutral.svg?react';
import { ReactComponent as SentimentPositive } from './svgs/sentiment-positive.svg?react';
import { ReactComponent as Settings } from './svgs/settings.svg?react';
import { ReactComponent as Share } from './svgs/share.svg?react';
import { ReactComponent as ShareOfVoice } from './svgs/share-of-voice.svg?react';
import { ReactComponent as SidebarClosed } from './svgs/sidebar.svg?react';
import { ReactComponent as SidebarOpened } from './svgs/sidebar-open.svg?react';
import { ReactComponent as Similarities } from './svgs/similarities.svg?react';
import { ReactComponent as Sliders } from './svgs/sliders.svg?react';
import { ReactComponent as Facebook } from './svgs/social-facebook.svg?react';
import { ReactComponent as Instagram } from './svgs/social-instagram.svg?react';
import { ReactComponent as LinkedIn } from './svgs/social-linkedin.svg?react';
import { ReactComponent as SocialMedia } from './svgs/social-media.svg?react';
import { ReactComponent as Mnd } from './svgs/social-mnd.svg?react';
import { ReactComponent as Tiktok } from './svgs/social-tiktok.svg?react';
import { ReactComponent as X } from './svgs/social-x.svg?react';
import { ReactComponent as Youtube } from './svgs/social-youtube.svg?react';
import { ReactComponent as Soundwaves } from './svgs/soundwaves.svg?react';
import { ReactComponent as Sparkle } from './svgs/sparkle.svg?react';
import { ReactComponent as Star } from './svgs/star.svg?react';
import { ReactComponent as StarFilled } from './svgs/star-filled.svg?react';
import { ReactComponent as Stop } from './svgs/stop.svg?react';
import { ReactComponent as Story } from './svgs/story.svg?react';
import { ReactComponent as Sun } from './svgs/sun.svg?react';
import { ReactComponent as TextFile } from './svgs/text-file.svg?react';
import { ReactComponent as ThumbsDown } from './svgs/thumbs-down.svg?react';
import { ReactComponent as ThumbsDownFilled } from './svgs/thumbs-down-filled.svg?react';
import { ReactComponent as ThumbsUp } from './svgs/thumbs-up.svg?react';
import { ReactComponent as ThumbsUpFilled } from './svgs/thumbs-up-filled.svg?react';
import { ReactComponent as Time } from './svgs/time.svg?react';
import { ReactComponent as Translate } from './svgs/translate.svg?react';
import { ReactComponent as TriangleExclamation } from './svgs/triangle-exclamation.svg?react';
import { ReactComponent as TriangleWarning } from './svgs/triangle-warning.svg?react';
import { ReactComponent as TV } from './svgs/tv.svg?react';
import { ReactComponent as TvWeb } from './svgs/tv_web.svg?react';
import { ReactComponent as Upload } from './svgs/upload.svg?react';
import { ReactComponent as User } from './svgs/user.svg?react';
import { ReactComponent as Visibility } from './svgs/visibility.svg?react';
import { ReactComponent as VisibilityOff } from './svgs/visibility-off.svg?react';
import { ReactComponent as Web } from './svgs/web.svg?react';
import { ReactComponent as Written } from './svgs/written.svg?react';

const wrapIcon = (Component: FC) => styled(SvgIconWrapper).attrs({ children: <Component /> })``;

export type WrapIconComponentType = ReturnType<typeof wrapIcon>;

const Warning = styled(TriangleExclamation)`
  color: ${props => props.theme.colorIconsWarning};
`;

const Error = styled(TriangleExclamation)`
  color: ${props => props.theme.colorIconsDanger};
`;

export const IconsSocialMedia = {
  Facebook: wrapIcon(Facebook),
  Instagram: wrapIcon(Instagram),
  LinkedIn: wrapIcon(LinkedIn),
  Youtube: wrapIcon(Youtube),
  X: wrapIcon(X),
  Tiktok: wrapIcon(Tiktok),
};

export const IconArrows = {
  ArrowDown: wrapIcon(ArrowDown),
  ArrowDownRight: wrapIcon(ArrowDownRight),
  ArrowUp: wrapIcon(ArrowUp),
  ArrowUpRight: wrapIcon(ArrowUpRight),
  ArrowRight: wrapIcon(ArrowRight),
  ArrowLeft: wrapIcon(ArrowLeft),

  ChevronLeft: wrapIcon(ChevronLeft),
  ChevronDown: wrapIcon(ChevronDown),
  ChevronUp: wrapIcon(ChevronUp),
  ChevronRight: wrapIcon(ChevronRight),
};

export const IconNotifications = {
  Notification: wrapIcon(Notification),
  CircleQuestion: wrapIcon(CircleQuestion),
  CircleError: wrapIcon(CircleError),
  CircleInfo: wrapIcon(CircleInfo),
  CircleInfoFilled: wrapIcon(CircleInfoFilled),
  TriangleWarning: wrapIcon(TriangleWarning),
  Warning: wrapIcon(Warning),
  Error: wrapIcon(Error),
};

export const IconReactions = {
  SentimentPositive: wrapIcon(SentimentPositive),
  SentimentNegative: wrapIcon(SentimentNegative),
  SentimentNeutral: wrapIcon(SentimentNeutral),

  ThumbsUpFilled: wrapIcon(ThumbsUpFilled),
  ThumbsUp: wrapIcon(ThumbsUp),
  ThumbsDownFilled: wrapIcon(ThumbsDownFilled),
  ThumbsDown: wrapIcon(ThumbsDown),
};

// Icons used for features that are acknowledged universally.
export const IconFeaturesUniversal = {
  Blog: wrapIcon(Blog),
  Calendar: wrapIcon(Calendar),
  Collapse: wrapIcon(Collapse),
  Close: wrapIcon(Close),
  Chat: wrapIcon(Chat),
  Check: wrapIcon(Check),
  CircleSlash: wrapIcon(CircleSlash),
  CircleUser: wrapIcon(CircleUser),
  Comment: wrapIcon(Comment),
  Contact: wrapIcon(Contact),
  ContactPlus: wrapIcon(ContactPlus),
  ContactCheck: wrapIcon(ContactCheck),
  Contacts: wrapIcon(Contacts),
  Copy: wrapIcon(Copy),
  DarkMode: wrapIcon(Moon),
  Delete: wrapIcon(Delete),
  DeleteSchedule: wrapIcon(DeleteSchedule),
  Download: wrapIcon(Download),
  Edit: wrapIcon(Edit),
  Email: wrapIcon(Email),
  EmailSchedule: wrapIcon(EmailSchedule),
  Expand: wrapIcon(Expand),
  ExternalLink: wrapIcon(ExternalLink),
  Forum: wrapIcon(Forum),
  Image: wrapIcon(Image), // thumbnail (name in Design System)
  LightMode: wrapIcon(Sun),
  Link: wrapIcon(Link),
  List: wrapIcon(List),
  Menu: wrapIcon(Menu),
  MoreHorizontal: wrapIcon(MoreHorizontal),
  MoreVertical: wrapIcon(MoreVertical),
  Play: wrapIcon(Play),
  Refresh: wrapIcon(Refresh),
  Replace: wrapIcon(Replace),
  Rss: wrapIcon(Rss),
  Search: wrapIcon(Search),
  Settings: wrapIcon(Settings),
  Share: wrapIcon(Share),
  Sliders: wrapIcon(Sliders),
  Translate: wrapIcon(Translate),
  Upload: wrapIcon(Upload),
  User: wrapIcon(User),
  Visibility: wrapIcon(Visibility),
  VisibilityOff: wrapIcon(VisibilityOff),
};

// Icons that are defined for MND's specific features.
export const IconFeaturesSpecial = {
  AddToList: wrapIcon(AddToList),
  Analyze: wrapIcon(Analyze),
  AnalyzeAlt: wrapIcon(AnalyzeAlt),
  Benchmark: wrapIcon(Benchmark),
  ContactsNavigation: wrapIcon(ContactsNavigation),
  ContactsNavigationActive: wrapIcon(ContactsNavigationActive),
  Dashboard: wrapIcon(Dashboard), // grid-view (name in Design System)
  DashboardActive: wrapIcon(DashboardActive),
  Debug: wrapIcon(Debug),
  DebugCookie: wrapIcon(DebugCookie),
  Mnd: wrapIcon(Mnd),
  MonitorNavigation: wrapIcon(MonitorNavigation),
  MonitorNavigationActive: wrapIcon(MonitorNavigationActive),
  Newsroom: wrapIcon(Newsroom),
  Publish: wrapIcon(Publish),
  PublishActive: wrapIcon(PublishActive),
  Reach: wrapIcon(Reach),
  Report: wrapIcon(Report),
  ReportsActive: wrapIcon(ReportsActive),
  Section: wrapIcon(Section),
  ShareOfVoice: wrapIcon(ShareOfVoice),
  SidebarOpened: wrapIcon(SidebarOpened), // hide-sidebar
  SidebarClosed: wrapIcon(SidebarClosed), // show-sidebar
  Story: wrapIcon(Story),
};

export const IconGeneral = {
  AdminShield: wrapIcon(AdminShield), // shield
  Astromech: wrapIcon(Astromech),
  Binoculars: wrapIcon(Binoculars),
  Boolean: wrapIcon(Boolean),
  CircleCheck: wrapIcon(CircleCheck),
  CircleCross: wrapIcon(CircleCross),
  CirclePlus: wrapIcon(CirclePlus),
  CreditCard: wrapIcon(CreditCard),
  Differences: wrapIcon(Differences),
  DollarSign: wrapIcon(DollarSign),
  EasterEgg: wrapIcon(EasterEgg),
  Globe: wrapIcon(Globe),
  Heart: wrapIcon(Heart),
  HeartFilled: wrapIcon(HeartFilled),
  LockLocked: wrapIcon(LockLocked), // lock
  LockUnlocked: wrapIcon(LockUnlocked), // unlock
  Minus: wrapIcon(Minus),
  Pen: wrapIcon(Pen), // edit-pen
  Pin: wrapIcon(Pin),
  PinFilled: wrapIcon(PinFilled),
  Plane: wrapIcon(Plane),
  Plus: wrapIcon(Plus),
  Podcast: wrapIcon(Podcast),
  Quote: wrapIcon(Quote),
  Radio: wrapIcon(Radio),
  Similarities: wrapIcon(Similarities),
  Sparkle: wrapIcon(Sparkle), // star-dust
  Star: wrapIcon(Star),
  StarFilled: wrapIcon(StarFilled),
  TvWeb: wrapIcon(TvWeb),
  Web: wrapIcon(Web),
};
// Icons that haven't been sorted yet or are not even in the Design System.
export const IconMiscellaneous = {
  CircleClock: wrapIcon(CircleClock),
  Crown: wrapIcon(Crown),
  CrownFancy: wrapIcon(CrowFancy),
  DefaultThumbnail: wrapIcon(DefaultThumbnail),
  Diamond: wrapIcon(Diamond),
  Computer: wrapIcon(Computer),
  Lighthouse: wrapIcon(Lighthouse),
  PasswordUnlock: wrapIcon(PasswordUnlock),
  Pencil: wrapIcon(Pencil),
  Code: wrapIcon(Code),
  Written: wrapIcon(Written),
  LearningVideo: wrapIcon(LearningVideo),
  TextFile: wrapIcon(TextFile),
  Phone: wrapIcon(Phone),
  Paperclip: wrapIcon(Paperclip),
  Time: wrapIcon(Time),
  Monitor: wrapIcon(Monitor),
  AnalyzeMenu: wrapIcon(AnalyzeMenu),
  Lightbulb: wrapIcon(Lightbulb),
  MndFilled: wrapIcon(MndFilled),
  AnalyzeNavigationActive: wrapIcon(AnalyzeNavigationActive),
  Tiktok: wrapIcon(Tiktok),
  SocialMedia: wrapIcon(SocialMedia), // smartphone
  TV: wrapIcon(TV),
  AdminShieldCookie: wrapIcon(AdminShieldCookie),
  LayoutStandard: wrapIcon(LayoutStandard),
  LayoutCompact: wrapIcon(LayoutCompact),
  PlayFilled: wrapIcon(PlayFilled),
  Stop: wrapIcon(Stop),
  Soundwaves: wrapIcon(Soundwaves),
};

export const Icons = {
  ...IconMiscellaneous,
  ...IconsSocialMedia,
  ...IconArrows,
  ...IconNotifications,
  ...IconGeneral,
  ...IconFeaturesUniversal,
  ...IconFeaturesSpecial,
  ...IconReactions,
};

export default Icons;
